/**
 * Frontend mapping from `Lead.failReason` (backend enum) to human-readable Spanish labels.
 * Keep in sync with `FAIL_REASONS` in `apps/saas_back/src/models/lead.ts`.
 */
export const FAIL_REASONS = [
  'no_whatsapp',
  'meta_blocked',
  'marketing_optout',
  'invalid_phone',
  'outside_24h_window',
  'rate_limited',
  'template_rejected',
  'unsupported_message',
  'account_blocked',
  'payment_issue',
  'follow_ups_disabled',
  'media_upload_failed',
  'provider_request_failed',
  'meta_server_error',
  'unknown',
] as const;

export type FailReason = (typeof FAIL_REASONS)[number];

export const FAIL_REASON_LABELS: Record<FailReason, string> = {
  no_whatsapp: 'No tiene WhatsApp',
  meta_blocked: 'Meta bloqueó entrega',
  marketing_optout: 'Cliente bloqueó marketing',
  invalid_phone: 'Teléfono inválido',
  outside_24h_window: 'Fuera de ventana 24h',
  rate_limited: 'Límite de tasa',
  template_rejected: 'Plantilla no aprobada',
  unsupported_message: 'Mensaje no soportado',
  account_blocked: 'Cuenta bloqueada',
  payment_issue: 'Problema de pago / facturación',
  follow_ups_disabled: 'Seguimientos deshabilitados',
  media_upload_failed: 'Error al subir archivo',
  provider_request_failed: 'Proveedor rechazó envío',
  meta_server_error: 'Error de servidor Meta',
  unknown: 'Desconocido',
};

/**
 * Sentinel value used in the `failReason` enum filter to represent the NULL bucket
 * (leads in the failed bucket that have no classified reason yet).
 *
 * The backend special-cases this token in `generalModelHelpers.ts` for the `failReason`
 * field with operator `in`/`isAnyOf`, OR-combining `IS NULL` with `IN (<rest>)`.
 *
 * Keep in sync with `apps/saas_back/src/utils/modelHelpers/generalModelHelpers.ts`.
 */
export const FAIL_REASON_UNCLASSIFIED_VALUE = '__null__';

export const FAIL_REASON_FILTER_OPTIONS = [
  ...FAIL_REASONS.map((value) => ({ value, label: FAIL_REASON_LABELS[value] })),
  { value: FAIL_REASON_UNCLASSIFIED_VALUE, label: 'Sin clasificar' },
];
